/**
 * Observa a sessão do Supabase Auth.
 *
 * O estado tem quatro possibilidades, e nenhuma delas pode ser confundida
 * com outra: ainda carregando, sem backend configurado (demonstração),
 * deslogado, e logado. Colapsar "carregando" em "deslogado" faria a tela de
 * login piscar para quem já está autenticado, a cada abertura.
 */
import { useEffect, useState } from 'react';

import { type EstadoSessao, supabase, supabaseConfigurado } from './sessao.ts';

export function usarSessao(): EstadoSessao {
  const [estado, setEstado] = useState<EstadoSessao>(() =>
    supabaseConfigurado() ? { estado: 'carregando' } : { estado: 'sem-backend' },
  );

  useEffect(() => {
    if (!supabaseConfigurado()) return;

    let vivo = true;
    const cliente = supabase();

    void cliente.auth.getSession().then(({ data }) => {
      if (!vivo) return;
      setEstado(data.session ? { estado: 'logado', sessao: data.session } : { estado: 'deslogado' });
    });

    // Cobre login, logout, e a renovação silenciosa do token: sem escutar,
    // a interface seguiria com um token expirado até o próximo recarregamento.
    const { data: assinatura } = cliente.auth.onAuthStateChange((_evento, sessao) => {
      if (!vivo) return;
      setEstado(sessao ? { estado: 'logado', sessao } : { estado: 'deslogado' });
    });

    return () => {
      vivo = false;
      assinatura.subscription.unsubscribe();
    };
  }, []);

  return estado;
}
